import api from './api';
import types from './mutation-types';

export default {
	async getCommCodeDetails_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodeDetails(codeType);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body.resultList });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'carScnList',
						value: data.body.CAR_SCN || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'ctypeList',
						value: data.body.CTYPE || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'flclSpcList',
						value: data.body.FLCL_SPC || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'idxScnList',
						value: data.body.IDX_SCN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'occuRegnList',
						value: data.body.OCCU_REGN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pacScnList',
						value: data.body.PAC_SCN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'phmnCdList',
						value: data.body.PHMN_CD || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'saleNatList',
						value: data.body.SALE_NAT || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'srchMm01List',
						value: data.body.SRCH_MM_01 || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'srchMm02List',
						value: data.body.SRCH_MM_02 || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'opCdList',
						value: data.body.OP_CD || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'useTermList',
						value: data.body.USE_TERM || []
					});
					// commit(types.DEFAULT_ASSIGN, {
					// 	key: 'carTypeNmList',
					// 	value: data.body.CAR_TYPE_NM || []
					// });
					commit(types.DEFAULT_ASSIGN, {
						key: 'plntCdList',
						value: data.body.PLNT_CD || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getgrdList_({ commit, state }) {
		const { searchParams } = state;
		return api
			.getgrdList({ searchParams: searchParams })
			.then(data => {
				if (data.header.code === 0) {
					//판매지역별분석 그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdList1',
						value: data?.body?.resultList || []
					});
					//현상코드별 그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdList2',
						value: data?.body?.phmnList || []
					});
					//dtc코드별 그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdList3',
						value: data?.body?.dtcList || []
					});
					//사용기간별 그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdList4',
						value: data?.body?.termList || []
					});
					//주행거리별 그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdList5',
						value: data?.body?.runList || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
